<template>
  <div>
    <b-modal
      id="modal-detail-historical-plan"
      dialogClass="full-width-modal"
      :title="`Historical Log Detail Budget Plan - ${activity}`"
      @hide="resetModal()"
      @show="showModal()"
      hide-footer
    >
      <div class="container-fluid">
        <div v-if="isLoading" class="row mb-3">
          <!-- Skeleton loader, misalnya tampilkan placeholder -->
          <b-skeleton animation="wave" width="100%"></b-skeleton>
          <b-skeleton animation="wave" width="100%"></b-skeleton>
          <b-skeleton animation="wave" width="100%"></b-skeleton>
          <b-skeleton animation="wave" width="100%"></b-skeleton>
          <!-- Tambahkan skeleton untuk seluruh konten yang memerlukan data -->
        </div>

        <div v-else>
          <!-- Bagian Header -->
          <div class="card">
            <div class="card-body">
              <h4>Activity Description</h4>
              <p>{{ logData?.activity_description }}</p>
            </div>
          </div>
          <div class="card">
            <div class="card-header">
              <h4 class="card-header-title">Detail Budget Plan</h4>
            </div>
            <div class="card-body">
              <div class="header">
                <div class="container-fluid">
                  <div class="row" v-if="isLoading">
                    <div class="col-12">
                      <div class="card">
                        <div class="row row-col-5 gx-3 gy-5 card-body">
                          <div class="col">
                            <div class="col-12 col-lg-6">
                              <b-skeleton animation="wave" width="45%"></b-skeleton>
                              <b-skeleton animation="wave" width="75%"></b-skeleton>
                            </div>
                          </div>
                          <div class="col">
                            <div class="col-12 col-lg-6">
                              <b-skeleton animation="wave" width="45%"></b-skeleton>
                              <b-skeleton animation="wave" width="75%"></b-skeleton>
                            </div>
                          </div>
                          <div class="col">
                            <div class="col-12 col-lg-6">
                              <b-skeleton animation="wave" width="45%"></b-skeleton>
                              <b-skeleton animation="wave" width="75%"></b-skeleton>
                            </div>
                          </div>
                          <div class="col">
                            <div class="col-12 col-lg-6">
                              <b-skeleton animation="wave" width="45%"></b-skeleton>
                              <b-skeleton animation="wave" width="75%"></b-skeleton>
                            </div>
                          </div>
                          <div class="col">
                            <div class="col-12 col-lg-6">
                              <b-skeleton animation="wave" width="45%"></b-skeleton>
                              <b-skeleton animation="wave" width="75%"></b-skeleton>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="card">
                        <div class="card-body row">
                          <div class="col-12 col-md-6">
                            <div class="card">
                              <div class="row gx-3 gy-5 card-body">
                                <div class="col-12 col-lg-6">
                                  <b-skeleton animation="wave" width="45%"></b-skeleton>
                                  <b-skeleton animation="wave" width="75%"></b-skeleton>
                                </div>
                                <div class="col-12 col-lg-6">
                                  <b-skeleton animation="wave" width="45%"></b-skeleton>
                                  <b-skeleton animation="wave" width="75%"></b-skeleton>
                                </div>
                                <div class="col-12 col-lg-6">
                                  <b-skeleton animation="wave" width="45%"></b-skeleton>
                                  <b-skeleton animation="wave" width="75%"></b-skeleton>
                                </div>
                                <div class="col-12 col-lg-6">
                                  <b-skeleton animation="wave" width="45%"></b-skeleton>
                                  <b-skeleton animation="wave" width="75%"></b-skeleton>
                                </div>
                                <div class="col-12 col-lg-6">
                                  <b-skeleton animation="wave" width="45%"></b-skeleton>
                                  <b-skeleton animation="wave" width="75%"></b-skeleton>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-12 col-md-6">
                            <div class="card">
                              <div class="card-body d-flex flex-column">
                                <div class="mt-2">
                                  <b-skeleton animation="wave" width="100%"></b-skeleton>
                                  <b-skeleton animation="wave" width="100%"></b-skeleton>
                                </div>
                                <div class="mt-2">
                                  <b-skeleton animation="wave" width="100%"></b-skeleton>
                                  <b-skeleton animation="wave" width="100%"></b-skeleton>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="card"></div>
                    </div>
                  </div>
                  <div class="row" v-if="!isLoading">
                    <div class="col-12">
                      <div class="card">
                        <div class="row row row-cols-1 row-cols-md-3 row-cols-xl-6 gx-5 gy-3 card-body">
                          <div class="col">
                            <div class="row align-items-center">
                              <div class="col-auto">
                                <div class="avatar avatar-sm">
                                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                    <i class="fe fe-clipboard"></i>
                                  </div>
                                </div>
                              </div>
                              <div class="col ms-n2">
                                <h4 class="mb-1 font-weight-bold">Budget title</h4>
                                <small class="text-body-secondary"
                                  ><span> {{ detail.title }}</span>
                                </small>
                              </div>
                            </div>
                          </div>
                          <div class="col">
                            <div class="row align-items-center">
                              <div class="col-auto">
                                <div class="avatar avatar-sm">
                                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                    <i class="fe fe-home"></i>
                                  </div>
                                </div>
                              </div>
                              <div class="col ms-n2">
                                <h4 class="mb-1 font-weight-bold">Department</h4>
                                <small class="text-body-secondary"
                                  ><span> {{ detail.fund_center?.department_code }} - {{ detail?.fund_center?.department_name }}</span>
                                </small>
                              </div>
                            </div>
                          </div>
                          <div class="col">
                            <div class="row align-items-center">
                              <div class="col-auto">
                                <div class="avatar avatar-sm">
                                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                    <i class="fe fe-credit-card"></i>
                                  </div>
                                </div>
                              </div>
                              <div class="col ms-n2">
                                <h4 class="mb-1 font-weight-bold">Fund Center</h4>
                                <small class="text-body-secondary"
                                  ><span> {{ detail.fund_center?.fund_center }}</span>
                                </small>
                              </div>
                            </div>
                          </div>
                          <div class="col">
                            <div class="row align-items-center">
                              <div class="col-auto">
                                <div class="avatar avatar-sm">
                                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                    <i class="fe fe-calendar"></i>
                                  </div>
                                </div>
                              </div>
                              <div class="col ms-n2">
                                <h4 class="mb-1 font-weight-bold">Year</h4>
                                <small class="text-body-secondary"
                                  ><span> {{ detail.year }}</span>
                                </small>
                              </div>
                            </div>
                          </div>
                          <div class="col">
                            <div class="row align-items-center">
                              <div class="col-auto">
                                <div class="avatar avatar-sm">
                                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                    <i class="fe fe-clipboard"></i>
                                  </div>
                                </div>
                              </div>
                              <div class="col ms-n2">
                                <h4 class="mb-1 font-weight-bold">Version</h4>
                                <small class="text-body-secondary"
                                  ><span> {{ detail.version }} </span>
                                </small>
                              </div>
                            </div>
                          </div>
                          <div class="col">
                            <div class="row align-items-center">
                              <div class="col-auto">
                                <div class="avatar avatar-sm">
                                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                    <i class="fe fe-dollar-sign"></i>
                                  </div>
                                </div>
                              </div>
                              <div class="col ms-n2">
                                <h4 class="mb-1 font-weight-bold">Total OPEX + CAPEX</h4>
                                <small class="text-body-secondary"
                                  ><span> {{ budgetPlanTotal }}</span>
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="card">
                        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-4 gx-3 gy-5 card-body">
                          <div class="col">
                            <div class="row align-items-center">
                              <div class="col-auto">
                                <div class="avatar avatar-sm">
                                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                    <i class="fe fe-calendar"></i>
                                  </div>
                                </div>
                              </div>
                              <div class="col ms-n2">
                                <h4 class="mb-1 font-weight-bold">Created At</h4>
                                <small class="text-body-secondary"
                                  ><span> {{ createdAt }}</span>
                                </small>
                              </div>
                            </div>
                          </div>
                          <div class="col">
                            <div class="row align-items-center">
                              <div class="col-auto">
                                <div class="avatar avatar-sm">
                                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                    <i class="fe fe-user"></i>
                                  </div>
                                </div>
                              </div>
                              <div class="col ms-n2">
                                <h4 class="mb-1 font-weight-bold">Created By</h4>
                                <small class="text-body-secondary"
                                  ><span> {{ createdBy }}</span>
                                </small>
                              </div>
                            </div>
                          </div>
                          <div class="col">
                            <div class="row align-items-center">
                              <div class="col-auto">
                                <div class="avatar avatar-sm">
                                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                    <i class="fe fe-calendar"></i>
                                  </div>
                                </div>
                              </div>
                              <div class="col ms-n2">
                                <h4 class="mb-1 font-weight-bold">Updated At</h4>
                                <small class="text-body-secondary"
                                  ><span> {{ updatedAt }}</span>
                                </small>
                              </div>
                            </div>
                          </div>
                          <div class="col">
                            <div class="row align-items-center">
                              <div class="col-auto">
                                <div class="avatar avatar-sm">
                                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                    <i class="fe fe-user"></i>
                                  </div>
                                </div>
                              </div>
                              <div class="col ms-n2">
                                <h4 class="mb-1 font-weight-bold">Updated By</h4>
                                <small class="text-body-secondary"
                                  ><span> {{ updatedBy }}</span>
                                </small>
                              </div>
                            </div>
                          </div>
                          <div class="col" v-if="detail.locked">
                            <div class="row align-items-center">
                              <div class="col-auto">
                                <div class="avatar avatar-sm">
                                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                    <i class="fe fe-calendar"></i>
                                  </div>
                                </div>
                              </div>
                              <div class="col ms-n2">
                                <h4 class="mb-1 font-weight-bold">Locked At</h4>
                                <small class="text-body-secondary"
                                  ><span> {{ lockedAt }}</span>
                                </small>
                              </div>
                            </div>
                          </div>
                          <div class="col" v-if="detail.locked">
                            <div class="row align-items-center">
                              <div class="col-auto">
                                <div class="avatar avatar-sm">
                                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                    <i class="fe fe-user"></i>
                                  </div>
                                </div>
                              </div>
                              <div class="col ms-n2">
                                <h4 class="mb-1 font-weight-bold">Locked By</h4>
                                <small class="text-body-secondary"
                                  ><span> {{ lockedBy }}</span>
                                </small>
                              </div>
                            </div>
                          </div>
                          <div class="col" v-if="detail?.all_version?.length != detail.version">
                            <div class="row align-items-center">
                              <div class="col-auto">
                                <div class="avatar avatar-sm">
                                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                    <i class="fe fe-calendar"></i>
                                  </div>
                                </div>
                              </div>
                              <div class="col ms-n2">
                                <h4 class="mb-1 font-weight-bold">Cloned At</h4>
                                <small class="text-body-secondary"
                                  ><span> {{ clonedAt }}</span>
                                </small>
                              </div>
                            </div>
                          </div>
                          <div class="col" v-if="detail?.all_version?.length != detail.version">
                            <div class="row align-items-center">
                              <div class="col-auto">
                                <div class="avatar avatar-sm">
                                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                    <i class="fe fe-user"></i>
                                  </div>
                                </div>
                              </div>
                              <div class="col ms-n2">
                                <h4 class="mb-1 font-weight-bold">Cloned By</h4>
                                <small class="text-body-secondary"
                                  ><span> {{ clonedBy }}</span>
                                </small>
                              </div>
                            </div>
                          </div>
                          <div class="col" v-if="detail?.histories?.some((h) => h.activity == 'APPROVE')">
                            <div class="row align-items-center">
                              <div class="col-auto">
                                <div class="avatar avatar-sm">
                                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                    <i class="fe fe-calendar"></i>
                                  </div>
                                </div>
                              </div>
                              <div class="col ms-n2">
                                <h4 class="mb-1 font-weight-bold">Approved At</h4>
                                <small class="text-body-secondary"
                                  ><span> {{ approvedAt }}</span>
                                </small>
                              </div>
                            </div>
                          </div>
                          <div class="col" v-if="detail?.histories?.some((h) => h.activity == 'APPROVE')">
                            <div class="row align-items-center">
                              <div class="col-auto">
                                <div class="avatar avatar-sm">
                                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                    <i class="fe fe-user"></i>
                                  </div>
                                </div>
                              </div>
                              <div class="col ms-n2">
                                <h4 class="mb-1 font-weight-bold">Approved By</h4>
                                <small class="text-body-secondary"
                                  ><span> {{ approvedBy }}</span>
                                </small>
                              </div>
                            </div>
                          </div>
                          <div class="col" v-if="detail?.histories?.some((h) => h.activity == 'DISAPPROVE')">
                            <div class="row align-items-center">
                              <div class="col-auto">
                                <div class="avatar avatar-sm">
                                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                    <i class="fe fe-calendar"></i>
                                  </div>
                                </div>
                              </div>
                              <div class="col ms-n2">
                                <h4 class="mb-1 font-weight-bold">Disapproved At</h4>
                                <small class="text-body-secondary"
                                  ><span> {{ disapprovedAt }}</span>
                                </small>
                              </div>
                            </div>
                          </div>
                          <div class="col" v-if="detail?.histories?.some((h) => h.activity == 'DISAPPROVE')">
                            <div class="row align-items-center">
                              <div class="col-auto">
                                <div class="avatar avatar-sm">
                                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                    <i class="fe fe-user"></i>
                                  </div>
                                </div>
                              </div>
                              <div class="col ms-n2">
                                <h4 class="mb-1 font-weight-bold">Disapproved By</h4>
                                <small class="text-body-secondary"
                                  ><span> {{ disapprovedBy }}</span>
                                </small>
                              </div>
                            </div>
                          </div>
                          <div class="col" v-if="logData?.activity == 'Delete'">
                            <div class="row align-items-center">
                              <div class="col-auto">
                                <div class="avatar avatar-sm">
                                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                    <i class="fe fe-calendar"></i>
                                  </div>
                                </div>
                              </div>
                              <div class="col ms-n2">
                                <h4 class="mb-1 font-weight-bold">Deleted At</h4>
                                <small class="text-body-secondary"
                                  ><span> {{ deletedAt }}</span>
                                </small>
                              </div>
                            </div>
                          </div>
                          <div class="col" v-if="logData?.activity == 'Delete'">
                            <div class="row align-items-center">
                              <div class="col-auto">
                                <div class="avatar avatar-sm">
                                  <div class="avatar-title fs-lg bg-primary-soft rounded-circle text-primary">
                                    <i class="fe fe-user"></i>
                                  </div>
                                </div>
                              </div>
                              <div class="col ms-n2">
                                <h4 class="mb-1 font-weight-bold">Deleted By</h4>
                                <small class="text-body-secondary"
                                  ><span> {{ deletedBy }}</span>
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="card">
                        <b-tabs pills card fill>
                          <b-tab :title="`OPEX : ${formatCurrency(detail.opex_total)}`">
                            <div style="overflow: auto">
                              <table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
                                <thead>
                                  <tr>
                                    <!-- <th style="width: 150px" v-if="role_id == 'Super Admin' || role_id == 'Admin'">Action</th> -->
                                    <th style="width: 100px">Code</th>
                                    <th style="width: 100px">GL</th>
                                    <th style="width: 350px">Budget Item</th>
                                    <th style="width: 150px">January</th>
                                    <th style="width: 150px">February</th>
                                    <th style="width: 150px">March</th>
                                    <th style="width: 150px">April</th>
                                    <th style="width: 150px">May</th>
                                    <th style="width: 150px">June</th>
                                    <th style="width: 150px">July</th>
                                    <th style="width: 150px">August</th>
                                    <th style="width: 150px">September</th>
                                    <th style="width: 150px">October</th>
                                    <th style="width: 150px">November</th>
                                    <th style="width: 150px">December</th>
                                    <th style="width: 150px">Total</th>
                                  </tr>
                                </thead>
                                <tbody v-for="(item, index) in detail.opex" :key="index">
                                  <tr class="opex-first">
                                    <!-- <td v-if="role_id == 'Super Admin' || role_id == 'Admin'"></td> -->
                                    <td class="bg-gray">{{ item.account.code }}</td>
                                    <td class="bg-gray"></td>
                                    <td class="bg-gray">
                                      {{ item.account.account }}
                                    </td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.jan) }}</td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.feb) }}</td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.mar) }}</td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.apr) }}</td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.may) }}</td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.jun) }}</td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.jul) }}</td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.aug) }}</td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.sep) }}</td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.oct) }}</td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.nov) }}</td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.dec) }}</td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.total) }}</td>
                                  </tr>

                                  <tr v-for="(list, indx) in item.opex_item" :key="indx" class="opex">
                                    <!-- <td v-if="role_id == 'Super Admin' || role_id == 'Admin'">
														<b-button variant="info" size="sm" block @click="sharePlan(list.id, 'plan_item_item_opex')">
															<span class="fe fe-share-2 mr-2"></span>Share</b-button
														>
													</td> -->
                                    <td>{{ list.budget_item.item }}</td>
                                    <td>{{ list.opex_gl?.gl_code }}</td>
                                    <td v-b-popover.hover.top="'Click here for more detail'" style="cursor: pointer" @click="detailBudget(list)">
                                      {{ list.budget_item.budget_item }}
                                      <span class="float-end fe fe-maximize-2"></span>
                                    </td>
                                    <td>{{ formatCurrency(list.summary.jan) }}</td>
                                    <td>{{ formatCurrency(list.summary.feb) }}</td>
                                    <td>{{ formatCurrency(list.summary.mar) }}</td>
                                    <td>{{ formatCurrency(list.summary.apr) }}</td>
                                    <td>{{ formatCurrency(list.summary.may) }}</td>
                                    <td>{{ formatCurrency(list.summary.jun) }}</td>
                                    <td>{{ formatCurrency(list.summary.jul) }}</td>
                                    <td>{{ formatCurrency(list.summary.aug) }}</td>
                                    <td>{{ formatCurrency(list.summary.sep) }}</td>
                                    <td>{{ formatCurrency(list.summary.oct) }}</td>
                                    <td>{{ formatCurrency(list.summary.nov) }}</td>
                                    <td>{{ formatCurrency(list.summary.dec) }}</td>
                                    <td>{{ formatCurrency(list.summary.total) }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </b-tab>
                          <b-tab :title="`CAPEX :  ${formatCurrency(detail.capex_total)}`">
                            <div style="overflow: auto">
                              <table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
                                <thead>
                                  <tr class="capex">
                                    <!-- <th style="width: 150px" v-if="role_id == 'Super Admin' || role_id == 'Admin'">Action</th> -->
                                    <th style="width: 150px">Fund</th>
                                    <th style="width: 150px">GL</th>
                                    <th style="width: 350px">Budget Item</th>
                                    <th style="width: 350px">Description</th>
                                    <th style="width: 150px">January</th>
                                    <th style="width: 150px">February</th>
                                    <th style="width: 150px">March</th>
                                    <th style="width: 150px">April</th>
                                    <th style="width: 150px">May</th>
                                    <th style="width: 150px">June</th>
                                    <th style="width: 150px">July</th>
                                    <th style="width: 150px">August</th>
                                    <th style="width: 150px">September</th>
                                    <th style="width: 150px">October</th>
                                    <th style="width: 150px">November</th>
                                    <th style="width: 150px">December</th>
                                    <th style="width: 150px">Total</th>
                                  </tr>
                                </thead>
                                <tbody v-for="(item, index) in detail.capex" :key="index">
                                  <tr class="capex-gl">
                                    <!-- <td v-if="role_id == 'Super Admin' || role_id == 'Admin'">
														<b-button variant="info" size="sm" block @click="sharePlan(item.id, 'plan_item_capex')">
															<span class="fe fe-share-2 mr-2"></span>Share</b-button
														>
													</td> 
													</td>-->
                                    <td class="bg-gray">{{ item?.fund?.fund }}</td>
                                    <td class="bg-gray">{{ item.capex_gl.gl_code }}</td>
                                    <td class="bg-gray">{{ item.account.account }}</td>
                                    <td class="bg-gray"></td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.jan) }}</td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.feb) }}</td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.mar) }}</td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.apr) }}</td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.may) }}</td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.jun) }}</td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.jul) }}</td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.aug) }}</td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.sep) }}</td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.oct) }}</td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.nov) }}</td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.dec) }}</td>
                                    <td class="bg-gray">{{ formatCurrency(item.summary.total) }}</td>
                                  </tr>

                                  <tr v-for="(list, indx) in item.budget" :key="indx" class="capex">
                                    <!-- <td v-if="role_id == 'Super Admin' || role_id == 'Admin'"></td> -->
                                    <td></td>
                                    <td></td>
                                    <td>{{ list.name }}</td>
                                    <td>{{ list.description }}</td>
                                    <td>{{ formatCurrency(list.jan) }}</td>
                                    <td>{{ formatCurrency(list.feb) }}</td>
                                    <td>{{ formatCurrency(list.mar) }}</td>
                                    <td>{{ formatCurrency(list.apr) }}</td>
                                    <td>{{ formatCurrency(list.may) }}</td>
                                    <td>{{ formatCurrency(list.jun) }}</td>
                                    <td>{{ formatCurrency(list.jul) }}</td>
                                    <td>{{ formatCurrency(list.aug) }}</td>
                                    <td>{{ formatCurrency(list.sep) }}</td>
                                    <td>{{ formatCurrency(list.oct) }}</td>
                                    <td>{{ formatCurrency(list.nov) }}</td>
                                    <td>{{ formatCurrency(list.dec) }}</td>
                                    <td>{{ formatCurrency(list.total) }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </b-tab>
                        </b-tabs>
                      </div>
                    </div>
                  </div>
                  <!-- Body -->
                </div>
              </div>
            </div>
          </div>
          <div class="card" v-if="logData?.activity == 'Update'">
            <div class="card-header">Changes</div>
            <div class="card-body">
              <div class="card" v-if="planChanges?.length > 0">
                <div class="card-header">Budget Plan</div>
                <div class="card-body">
                  <vsa-list style="max-width: 100% !important ; border: none">
                    <vsa-item v-for="(item, indexItem) in planChanges" :key="indexItem" class="mb-2 border border-warning">
                      <vsa-heading>
                        <div class="font-weight-bold">
                          <span class="badge bg-warning">Modified</span>
                          {{ item?.category && item.category.slice(0, 1).toUpperCase() + item.category.slice(1) }}
                        </div>
                      </vsa-heading>
                      <vsa-content>
                        <div class="row">
                          <div class="col-6"><span class="badge bg-primary mr-2">Old</span>{{ item.old }}</div>
                          <div class="col-6"><span class="badge bg-success mr-2">New</span>{{ item.new }}</div>
                        </div>
                      </vsa-content>
                    </vsa-item>
                  </vsa-list>
                </div>
              </div>
              <b-tabs pills card fill>
                <b-tab :title="`OPEX`">
                  <div class="card">
                    <div class="card-header">Transactions</div>
                    <div class="card-body">
                      <div class="row" v-if="opexChanges?.opexDiff?.length > 0">
                        <vsa-list style="max-width: 100% !important ; border: none">
                          <vsa-item
                            v-for="(transaction, indexTransaction) in opexChanges.opexDiff"
                            :key="indexTransaction"
                            :class="`mb-2 ${
                              transaction.type === 'deleted' || transaction.type === 'transfer_out'
                                ? 'border border-danger'
                                : transaction.type === 'added' || transaction.type === 'transfer_in'
                                ? 'border border-success'
                                : 'border border-warning'
                            }`"
                          >
                            <vsa-heading>
                              <div class="font-weight-bold">
                                <span v-if="transaction.type === 'deleted' || transaction.type === 'transfer_out'" class="badge bg-red">{{
                                  transaction.type === 'deleted' ? 'Deleted' : 'Transfered'
                                }}</span>
                                <span v-else-if="transaction.type === 'added' || transaction.type === 'transfer_in'" class="badge bg-success">{{
                                  transaction.type === 'added' ? 'Added' : 'Transfered'
                                }}</span>
                                <span v-else class="badge bg-warning">Modified</span>
                                {{
                                  transaction.type === 'deleted' || transaction.type === 'transfer_out'
                                    ? transaction.old.account_name
                                    : transaction.new.account_name
                                }}
                              </div>
                            </vsa-heading>
                            <vsa-content>
                              <!-- id old -->
                              <div class="mb-3 p-2" v-for="(item, indexItem) in transaction?.old?.items">
                                <span>Budget Item : {{ item.item_name }}</span>
                                <div style="overflow: auto">
                                  <table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
                                    <thead>
                                      <tr>
                                        <th style="width: 350px">Budget Task</th>
                                        <th style="width: 350px">Description</th>
                                        <th style="width: 150px">January</th>
                                        <th style="width: 150px">February</th>
                                        <th style="width: 150px">March</th>
                                        <th style="width: 150px">April</th>
                                        <th style="width: 150px">May</th>
                                        <th style="width: 150px">June</th>
                                        <th style="width: 150px">July</th>
                                        <th style="width: 150px">August</th>
                                        <th style="width: 150px">September</th>
                                        <th style="width: 150px">October</th>
                                        <th style="width: 150px">November</th>
                                        <th style="width: 150px">December</th>
                                        <th style="width: 150px">Total</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(task, indx) in item?.tasks" :key="indx" class="opex">
                                        <td>{{ task.name }}</td>
                                        <td>{{ task.description }}</td>
                                        <td>{{ formatCurrency(task.jan) }}</td>
                                        <td>{{ formatCurrency(task.feb) }}</td>
                                        <td>{{ formatCurrency(task.mar) }}</td>
                                        <td>{{ formatCurrency(task.apr) }}</td>
                                        <td>{{ formatCurrency(task.may) }}</td>
                                        <td>{{ formatCurrency(task.jun) }}</td>
                                        <td>{{ formatCurrency(task.jul) }}</td>
                                        <td>{{ formatCurrency(task.aug) }}</td>
                                        <td>{{ formatCurrency(task.sep) }}</td>
                                        <td>{{ formatCurrency(task.oct) }}</td>
                                        <td>{{ formatCurrency(task.nov) }}</td>
                                        <td>{{ formatCurrency(task.dec) }}</td>
                                        <td>{{ formatCurrency(task.total) }}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              <!-- id new -->
                              <div
                                :class="
                                  transaction.type === 'deleted' || transaction.type === 'transfer_out'
                                    ? 'border border-danger mb-3 p-2'
                                    : 'border border-success mb-3 p-2'
                                "
                                v-for="(item, indexItem) in transaction?.new?.items"
                              >
                                <span>Budget Item : {{ item.item_name }}</span>
                                <div style="overflow: auto">
                                  <table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
                                    <thead>
                                      <tr>
                                        <th style="width: 350px">Budget Task</th>
                                        <th style="width: 350px">Description</th>
                                        <th style="width: 150px">January</th>
                                        <th style="width: 150px">February</th>
                                        <th style="width: 150px">March</th>
                                        <th style="width: 150px">April</th>
                                        <th style="width: 150px">May</th>
                                        <th style="width: 150px">June</th>
                                        <th style="width: 150px">July</th>
                                        <th style="width: 150px">August</th>
                                        <th style="width: 150px">September</th>
                                        <th style="width: 150px">October</th>
                                        <th style="width: 150px">November</th>
                                        <th style="width: 150px">December</th>
                                        <th style="width: 150px">Total</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(task, indx) in item?.tasks" :key="indx" class="opex">
                                        <td>{{ task.name }}</td>
                                        <td>{{ task.description }}</td>
                                        <td>{{ formatCurrency(task.jan) }}</td>
                                        <td>{{ formatCurrency(task.feb) }}</td>
                                        <td>{{ formatCurrency(task.mar) }}</td>
                                        <td>{{ formatCurrency(task.apr) }}</td>
                                        <td>{{ formatCurrency(task.may) }}</td>
                                        <td>{{ formatCurrency(task.jun) }}</td>
                                        <td>{{ formatCurrency(task.jul) }}</td>
                                        <td>{{ formatCurrency(task.aug) }}</td>
                                        <td>{{ formatCurrency(task.sep) }}</td>
                                        <td>{{ formatCurrency(task.oct) }}</td>
                                        <td>{{ formatCurrency(task.nov) }}</td>
                                        <td>{{ formatCurrency(task.dec) }}</td>
                                        <td>{{ formatCurrency(task.total) }}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </vsa-content>
                          </vsa-item>
                        </vsa-list>
                      </div>
                      <div class="row" v-else>
                        <div class="col-12 text-center text-info p-3">No Changes</div>
                      </div>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-header">Budget Items</div>
                    <div class="card-body">
                      <div class="row" v-if="opexChanges?.opexItemDiff?.length > 0">
                        <vsa-list style="max-width: 100% !important; border: none">
                          <vsa-item
                            v-for="(item, indexItem) in opexChanges.opexItemDiff"
                            :key="indexItem"
                            :class="`mb-2 ${
                              item.type === 'deleted' || item.type === 'transfer_out'
                                ? 'border border-danger'
                                : item.type === 'added' || item.type === 'transfer_in'
                                ? 'border border-success'
                                : 'border border-warning'
                            }`"
                          >
                            <vsa-heading>
                              <div class="font-weight-bold">
                                <span v-if="item.type === 'deleted' || item.type === 'transfer_out'" class="badge bg-red">{{
                                  item.type === 'deleted' ? 'Deleted' : 'Transfered'
                                }}</span>
                                <span v-else-if="item.type === 'added' || item.type === 'transfer_in'" class="badge bg-success">{{
                                  item.type === 'added' ? 'Added' : 'Transfered'
                                }}</span>
                                <span v-else class="badge bg-warning">Modified</span>
                                {{
                                  item.type === 'deleted' || item.type === 'transfer_out'
                                    ? `${item.old?.gl_code} | ${item.old?.item_name}`
                                    : `${item.new?.gl_code} | ${item.new?.item_name}`
                                }}
                              </div>
                            </vsa-heading>
                            <vsa-content>
                              <div class="mb-3 p-2">
                                <span>Transaction : {{ item.transaction_name }}</span>
                                <div style="overflow: auto">
                                  <table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
                                    <thead>
                                      <tr>
                                        <th style="width: 350px">Budget Task</th>
                                        <th style="width: 350px">Description</th>
                                        <th style="width: 150px">January</th>
                                        <th style="width: 150px">February</th>
                                        <th style="width: 150px">March</th>
                                        <th style="width: 150px">April</th>
                                        <th style="width: 150px">May</th>
                                        <th style="width: 150px">June</th>
                                        <th style="width: 150px">July</th>
                                        <th style="width: 150px">August</th>
                                        <th style="width: 150px">September</th>
                                        <th style="width: 150px">October</th>
                                        <th style="width: 150px">November</th>
                                        <th style="width: 150px">December</th>
                                        <th style="width: 150px">Total</th>
                                      </tr>
                                    </thead>
                                    <!-- id old -->
                                    <tbody v-if="item.type === 'deleted' || item.type === 'transfer_out'">
                                      <tr v-for="(task, indx) in item.old?.tasks" :key="indx" class="opex">
                                        <td>{{ task.name }}</td>
                                        <td>{{ task.description }}</td>
                                        <td>{{ formatCurrency(task.jan) }}</td>
                                        <td>{{ formatCurrency(task.feb) }}</td>
                                        <td>{{ formatCurrency(task.mar) }}</td>
                                        <td>{{ formatCurrency(task.apr) }}</td>
                                        <td>{{ formatCurrency(task.may) }}</td>
                                        <td>{{ formatCurrency(task.jun) }}</td>
                                        <td>{{ formatCurrency(task.jul) }}</td>
                                        <td>{{ formatCurrency(task.aug) }}</td>
                                        <td>{{ formatCurrency(task.sep) }}</td>
                                        <td>{{ formatCurrency(task.oct) }}</td>
                                        <td>{{ formatCurrency(task.nov) }}</td>
                                        <td>{{ formatCurrency(task.dec) }}</td>
                                        <td>{{ formatCurrency(task.total) }}</td>
                                      </tr>
                                    </tbody>
                                    <tbody v-else>
                                      <!-- id new -->
                                      <tr v-for="(task, indx) in item.new?.tasks" :key="indx" class="opex">
                                        <td>{{ task.name }}</td>
                                        <td>{{ task.description }}</td>
                                        <td>{{ formatCurrency(task.jan) }}</td>
                                        <td>{{ formatCurrency(task.feb) }}</td>
                                        <td>{{ formatCurrency(task.mar) }}</td>
                                        <td>{{ formatCurrency(task.apr) }}</td>
                                        <td>{{ formatCurrency(task.may) }}</td>
                                        <td>{{ formatCurrency(task.jun) }}</td>
                                        <td>{{ formatCurrency(task.jul) }}</td>
                                        <td>{{ formatCurrency(task.aug) }}</td>
                                        <td>{{ formatCurrency(task.sep) }}</td>
                                        <td>{{ formatCurrency(task.oct) }}</td>
                                        <td>{{ formatCurrency(task.nov) }}</td>
                                        <td>{{ formatCurrency(task.dec) }}</td>
                                        <td>{{ formatCurrency(task.total) }}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </vsa-content>
                          </vsa-item>
                        </vsa-list>
                      </div>
                      <div v-else class="row">
                        <div class="col-12 text-center text-info p-3">No Changes</div>
                      </div>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-header">Budget Task</div>
                    <div class="card-body">
                      <div class="row" v-if="opexChanges?.opexTaskDiff?.length > 0">
                        <vsa-list style="max-width: 100% !important; border: none">
                          <vsa-item
                            v-for="(task, indexTask) in opexChanges.opexTaskDiff"
                            :key="indexTask"
                            :class="`mb-2 ${
                              task.type === 'deleted' || task.type === 'transfer_out'
                                ? 'border border-danger'
                                : task.type === 'added' || task.type === 'transfer_in'
                                ? 'border border-success'
                                : 'border border-warning'
                            }`"
                          >
                            <vsa-heading>
                              <div class="font-weight-bold">
                                <span v-if="task.type === 'deleted' || task.type === 'transfer_out'" class="badge bg-red">{{
                                  task.type === 'deleted' ? 'Deleted' : 'Transfered'
                                }}</span>
                                <span v-else-if="task.type === 'added' || task.type === 'transfer_in'" class="badge bg-success">{{
                                  task.type === 'added' ? 'Added' : 'Transfered'
                                }}</span>
                                <span v-else class="badge bg-warning">Modified</span>
                                {{ task.type === 'deleted' || task.type === 'transfer_out' ? `${task.old?.name}` : `${task.new?.name}` }}
                              </div>
                            </vsa-heading>
                            <vsa-content>
                              <div class="mb-3 p-2">
                                <span>Transaction : {{ task.transaction_name }}</span
                                ><br />
                                <span>Item : {{ task.item_name }}</span>
                                <div style="overflow: auto">
                                  <table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
                                    <thead>
                                      <tr>
                                        <th style="width: 350px">Budget Task</th>
                                        <th style="width: 350px">Description</th>
                                        <th style="width: 150px">January</th>
                                        <th style="width: 150px">February</th>
                                        <th style="width: 150px">March</th>
                                        <th style="width: 150px">April</th>
                                        <th style="width: 150px">May</th>
                                        <th style="width: 150px">June</th>
                                        <th style="width: 150px">July</th>
                                        <th style="width: 150px">August</th>
                                        <th style="width: 150px">September</th>
                                        <th style="width: 150px">October</th>
                                        <th style="width: 150px">November</th>
                                        <th style="width: 150px">December</th>
                                        <th style="width: 150px">Total</th>
                                      </tr>
                                    </thead>
                                    <!-- id old -->
                                    <tbody>
                                      <tr class="opex" v-if="task.type === 'deleted' || task.type === 'transfer_out'">
                                        <td><span class="badge bg-red mr-2">Old</span>{{ task.old?.name }}</td>
                                        <td>{{ task.old?.description }}</td>
                                        <td>{{ formatCurrency(task.old?.jan) }}</td>
                                        <td>{{ formatCurrency(task.old?.feb) }}</td>
                                        <td>{{ formatCurrency(task.old?.mar) }}</td>
                                        <td>{{ formatCurrency(task.old?.apr) }}</td>
                                        <td>{{ formatCurrency(task.old?.may) }}</td>
                                        <td>{{ formatCurrency(task.old?.jun) }}</td>
                                        <td>{{ formatCurrency(task.old?.jul) }}</td>
                                        <td>{{ formatCurrency(task.old?.aug) }}</td>
                                        <td>{{ formatCurrency(task.old?.sep) }}</td>
                                        <td>{{ formatCurrency(task.old?.oct) }}</td>
                                        <td>{{ formatCurrency(task.old?.nov) }}</td>
                                        <td>{{ formatCurrency(task.old?.dec) }}</td>
                                        <td>{{ formatCurrency(task.old?.total) }}</td>
                                      </tr>
                                      <tr class="opex" v-if="task.type === 'added' || task.type === 'transfer_in'">
                                        <td><span class="badge bg-green mr-2">New</span>{{ task.new?.name }}</td>
                                        <td>{{ task.new?.description }}</td>
                                        <td>{{ formatCurrency(task.new?.jan) }}</td>
                                        <td>{{ formatCurrency(task.new?.feb) }}</td>
                                        <td>{{ formatCurrency(task.new?.mar) }}</td>
                                        <td>{{ formatCurrency(task.new?.apr) }}</td>
                                        <td>{{ formatCurrency(task.new?.may) }}</td>
                                        <td>{{ formatCurrency(task.new?.jun) }}</td>
                                        <td>{{ formatCurrency(task.new?.jul) }}</td>
                                        <td>{{ formatCurrency(task.new?.aug) }}</td>
                                        <td>{{ formatCurrency(task.new?.sep) }}</td>
                                        <td>{{ formatCurrency(task.new?.oct) }}</td>
                                        <td>{{ formatCurrency(task.new?.nov) }}</td>
                                        <td>{{ formatCurrency(task.new?.dec) }}</td>
                                        <td>{{ formatCurrency(task.new?.total) }}</td>
                                      </tr>
                                      <tr class="opex" v-if="task.type === 'modified'">
                                        <td><span class="badge bg-red mr-2">Old</span>{{ task.old?.name }}</td>
                                        <td>{{ task.old?.description }}</td>
                                        <td>{{ formatCurrency(task.old?.jan) }}</td>
                                        <td>{{ formatCurrency(task.old?.feb) }}</td>
                                        <td>{{ formatCurrency(task.old?.mar) }}</td>
                                        <td>{{ formatCurrency(task.old?.apr) }}</td>
                                        <td>{{ formatCurrency(task.old?.may) }}</td>
                                        <td>{{ formatCurrency(task.old?.jun) }}</td>
                                        <td>{{ formatCurrency(task.old?.jul) }}</td>
                                        <td>{{ formatCurrency(task.old?.aug) }}</td>
                                        <td>{{ formatCurrency(task.old?.sep) }}</td>
                                        <td>{{ formatCurrency(task.old?.oct) }}</td>
                                        <td>{{ formatCurrency(task.old?.nov) }}</td>
                                        <td>{{ formatCurrency(task.old?.dec) }}</td>
                                        <td>{{ formatCurrency(task.old?.total) }}</td>
                                      </tr>
                                      <tr class="opex" v-if="task.type === 'modified'">
                                        <td :class="`${task.new?.name !== task.old?.name ? 'td-green' : ''}`">
                                          <span class="badge bg-green mr-2">New</span>{{ task.new?.name }}
                                        </td>
                                        <td :class="`${task.new?.description !== task.old?.description ? 'td-green' : ''}`">
                                          {{ task.new?.description }}
                                        </td>
                                        <td :class="`${task.new?.jan !== task.old?.jan ? 'td-green' : ''}`">{{ formatCurrency(task.new?.jan) }}</td>
                                        <td :class="`${task.new?.feb !== task.old?.feb ? 'td-green' : ''}`">{{ formatCurrency(task.new?.feb) }}</td>
                                        <td :class="`${task.new?.mar !== task.old?.mar ? 'td-green' : ''}`">{{ formatCurrency(task.new?.mar) }}</td>
                                        <td :class="`${task.new?.apr !== task.old?.apr ? 'td-green' : ''}`">{{ formatCurrency(task.new?.apr) }}</td>
                                        <td :class="`${task.new?.may !== task.old?.may ? 'td-green' : ''}`">{{ formatCurrency(task.new?.may) }}</td>
                                        <td :class="`${task.new?.jun !== task.old?.jun ? 'td-green' : ''}`">{{ formatCurrency(task.new?.jun) }}</td>
                                        <td :class="`${task.new?.jul !== task.old?.jul ? 'td-green' : ''}`">{{ formatCurrency(task.new?.jul) }}</td>
                                        <td :class="`${task.new?.aug !== task.old?.aug ? 'td-green' : ''}`">{{ formatCurrency(task.new?.aug) }}</td>
                                        <td :class="`${task.new?.sep !== task.old?.sep ? 'td-green' : ''}`">{{ formatCurrency(task.new?.sep) }}</td>
                                        <td :class="`${task.new?.oct !== task.old?.oct ? 'td-green' : ''}`">{{ formatCurrency(task.new?.oct) }}</td>
                                        <td :class="`${task.new?.nov !== task.old?.nov ? 'td-green' : ''}`">{{ formatCurrency(task.new?.nov) }}</td>
                                        <td :class="`${task.new?.dec !== task.old?.dec ? 'td-green' : ''}`">{{ formatCurrency(task.new?.dec) }}</td>
                                        <td :class="`${task.new?.total !== task.old?.total ? 'td-green' : ''}`">
                                          {{ formatCurrency(task.new?.total) }}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </vsa-content>
                          </vsa-item>
                        </vsa-list>
                      </div>
                      <div v-else class="row">
                        <div class="col-12 text-center text-info p-3">No Changes</div>
                      </div>
                    </div>
                  </div>
                </b-tab>
                <b-tab :title="`CAPEX`">
                  <div class="card">
                    <div class="card-header">Budget Items</div>
                    <div class="card-body">
                      <div class="row" v-if="capexChanges?.capexDiff?.length > 0">
                        <vsa-list style="max-width: 100% !important; border: none">
                          <vsa-item
                            v-for="(item, indexItem) in capexChanges.capexDiff"
                            :key="indexItem"
                            :class="`mb-2 ${
                              item.type === 'deleted'
                                ? 'border border-danger'
                                : item.type === 'modified'
                                ? 'border border-warning'
                                : 'border border-success'
                            }`"
                          >
                            <vsa-heading>
                              <div class="font-weight-bold">
                                <span v-if="item.type === 'deleted'" class="badge bg-red">Deleted</span>
                                <span v-else class="badge bg-green">Added</span>
                                {{
                                  item.type === 'deleted'
                                    ? `${item.old?.fund || ''} - ${item.old?.account_name}`
                                    : `${item.new?.fund || ''} - ${item.new?.account_name}`
                                }}
                              </div>
                            </vsa-heading>
                            <vsa-content>
                              <div class="mb-3 p-2">
                                <div style="overflow: auto">
                                  <table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
                                    <thead>
                                      <tr>
                                        <th style="width: 350px">Budget Task</th>
                                        <th style="width: 350px">Description</th>
                                        <th style="width: 150px">January</th>
                                        <th style="width: 150px">February</th>
                                        <th style="width: 150px">March</th>
                                        <th style="width: 150px">April</th>
                                        <th style="width: 150px">May</th>
                                        <th style="width: 150px">June</th>
                                        <th style="width: 150px">July</th>
                                        <th style="width: 150px">August</th>
                                        <th style="width: 150px">September</th>
                                        <th style="width: 150px">October</th>
                                        <th style="width: 150px">November</th>
                                        <th style="width: 150px">December</th>
                                        <th style="width: 150px">Total</th>
                                      </tr>
                                    </thead>
                                    <!-- id old -->
                                    <tbody v-if="item.type === 'deleted'">
                                      <tr v-for="(task, indx) in item.old?.tasks" :key="indx" class="opex">
                                        <td>{{ task.name }}</td>
                                        <td>{{ task.description }}</td>
                                        <td>{{ formatCurrency(task.jan) }}</td>
                                        <td>{{ formatCurrency(task.feb) }}</td>
                                        <td>{{ formatCurrency(task.mar) }}</td>
                                        <td>{{ formatCurrency(task.apr) }}</td>
                                        <td>{{ formatCurrency(task.may) }}</td>
                                        <td>{{ formatCurrency(task.jun) }}</td>
                                        <td>{{ formatCurrency(task.jul) }}</td>
                                        <td>{{ formatCurrency(task.aug) }}</td>
                                        <td>{{ formatCurrency(task.sep) }}</td>
                                        <td>{{ formatCurrency(task.oct) }}</td>
                                        <td>{{ formatCurrency(task.nov) }}</td>
                                        <td>{{ formatCurrency(task.dec) }}</td>
                                        <td>{{ formatCurrency(task.total) }}</td>
                                      </tr>
                                    </tbody>
                                    <tbody v-else>
                                      <!-- id new -->
                                      <tr v-for="(task, indx) in item.new?.tasks" :key="indx" class="opex">
                                        <td>{{ task.name }}</td>
                                        <td>{{ task.description }}</td>
                                        <td>{{ formatCurrency(task.jan) }}</td>
                                        <td>{{ formatCurrency(task.feb) }}</td>
                                        <td>{{ formatCurrency(task.mar) }}</td>
                                        <td>{{ formatCurrency(task.apr) }}</td>
                                        <td>{{ formatCurrency(task.may) }}</td>
                                        <td>{{ formatCurrency(task.jun) }}</td>
                                        <td>{{ formatCurrency(task.jul) }}</td>
                                        <td>{{ formatCurrency(task.aug) }}</td>
                                        <td>{{ formatCurrency(task.sep) }}</td>
                                        <td>{{ formatCurrency(task.oct) }}</td>
                                        <td>{{ formatCurrency(task.nov) }}</td>
                                        <td>{{ formatCurrency(task.dec) }}</td>
                                        <td>{{ formatCurrency(task.total) }}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </vsa-content>
                          </vsa-item>
                        </vsa-list>
                      </div>
                      <div v-else class="row">
                        <div class="col-12 text-center text-info p-3">No Changes</div>
                      </div>
                    </div>
                  </div>
                  <div class="card">
                    <div class="card-header">Budget Task</div>
                    <div class="card-body">
                      <div class="row" v-if="capexChanges?.capexTaskDiff?.length > 0">
                        <vsa-list style="max-width: 100% !important; border: none">
                          <vsa-item
                            v-for="(task, indexTask) in capexChanges.capexTaskDiff"
                            :key="indexTask"
                            :class="`mb-2 ${
                              task.type === 'deleted'
                                ? 'border border-danger'
                                : task.type === 'modified'
                                ? 'border border-warning'
                                : 'border border-success'
                            }`"
                          >
                            <vsa-heading>
                              <div class="font-weight-bold">
                                <span :class="`badge ${task.type === 'deleted' ? 'bg-red' : task.type === 'modified' ? 'bg-yellow' : 'bg-green'}`">{{
                                  task.type === 'deleted' ? 'Deleted' : task.type === 'modified' ? 'Modified' : 'Added'
                                }}</span>
                                {{ task.type === 'deleted' ? `${task.old?.name}` : `${task.new?.name}` }}
                              </div>
                            </vsa-heading>
                            <vsa-content>
                              <div class="mb-3 p-2">
                                <span>Item : {{ task.item_name }}</span>
                                <div style="overflow: auto">
                                  <table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
                                    <thead>
                                      <tr>
                                        <th style="width: 350px">Budget Task</th>
                                        <th style="width: 350px">Description</th>
                                        <th style="width: 150px">January</th>
                                        <th style="width: 150px">February</th>
                                        <th style="width: 150px">March</th>
                                        <th style="width: 150px">April</th>
                                        <th style="width: 150px">May</th>
                                        <th style="width: 150px">June</th>
                                        <th style="width: 150px">July</th>
                                        <th style="width: 150px">August</th>
                                        <th style="width: 150px">September</th>
                                        <th style="width: 150px">October</th>
                                        <th style="width: 150px">November</th>
                                        <th style="width: 150px">December</th>
                                        <th style="width: 150px">Total</th>
                                      </tr>
                                    </thead>
                                    <!-- id old -->
                                    <tbody>
                                      <tr class="opex" v-if="task.type === 'deleted'">
                                        <td><span class="badge bg-red mr-2">Old</span>{{ task.old?.name }}</td>
                                        <td>{{ task.old?.description }}</td>
                                        <td>{{ formatCurrency(task.old?.jan) }}</td>
                                        <td>{{ formatCurrency(task.old?.feb) }}</td>
                                        <td>{{ formatCurrency(task.old?.mar) }}</td>
                                        <td>{{ formatCurrency(task.old?.apr) }}</td>
                                        <td>{{ formatCurrency(task.old?.may) }}</td>
                                        <td>{{ formatCurrency(task.old?.jun) }}</td>
                                        <td>{{ formatCurrency(task.old?.jul) }}</td>
                                        <td>{{ formatCurrency(task.old?.aug) }}</td>
                                        <td>{{ formatCurrency(task.old?.sep) }}</td>
                                        <td>{{ formatCurrency(task.old?.oct) }}</td>
                                        <td>{{ formatCurrency(task.old?.nov) }}</td>
                                        <td>{{ formatCurrency(task.old?.dec) }}</td>
                                        <td>{{ formatCurrency(task.old?.total) }}</td>
                                      </tr>
                                      <tr class="opex" v-if="task.type === 'added'">
                                        <td><span class="badge bg-green mr-2">New</span>{{ task.new?.name }}</td>
                                        <td>{{ task.new?.description }}</td>
                                        <td>{{ formatCurrency(task.new?.jan) }}</td>
                                        <td>{{ formatCurrency(task.new?.feb) }}</td>
                                        <td>{{ formatCurrency(task.new?.mar) }}</td>
                                        <td>{{ formatCurrency(task.new?.apr) }}</td>
                                        <td>{{ formatCurrency(task.new?.may) }}</td>
                                        <td>{{ formatCurrency(task.new?.jun) }}</td>
                                        <td>{{ formatCurrency(task.new?.jul) }}</td>
                                        <td>{{ formatCurrency(task.new?.aug) }}</td>
                                        <td>{{ formatCurrency(task.new?.sep) }}</td>
                                        <td>{{ formatCurrency(task.new?.oct) }}</td>
                                        <td>{{ formatCurrency(task.new?.nov) }}</td>
                                        <td>{{ formatCurrency(task.new?.dec) }}</td>
                                        <td>{{ formatCurrency(task.new?.total) }}</td>
                                      </tr>
                                      <tr class="opex" v-if="task.type === 'modified'">
                                        <td><span class="badge bg-red mr-2">Old</span>{{ task.old?.name }}</td>
                                        <td>{{ task.old?.description }}</td>
                                        <td>{{ formatCurrency(task.old?.jan) }}</td>
                                        <td>{{ formatCurrency(task.old?.feb) }}</td>
                                        <td>{{ formatCurrency(task.old?.mar) }}</td>
                                        <td>{{ formatCurrency(task.old?.apr) }}</td>
                                        <td>{{ formatCurrency(task.old?.may) }}</td>
                                        <td>{{ formatCurrency(task.old?.jun) }}</td>
                                        <td>{{ formatCurrency(task.old?.jul) }}</td>
                                        <td>{{ formatCurrency(task.old?.aug) }}</td>
                                        <td>{{ formatCurrency(task.old?.sep) }}</td>
                                        <td>{{ formatCurrency(task.old?.oct) }}</td>
                                        <td>{{ formatCurrency(task.old?.nov) }}</td>
                                        <td>{{ formatCurrency(task.old?.dec) }}</td>
                                        <td>{{ formatCurrency(task.old?.total) }}</td>
                                      </tr>
                                      <tr class="opex" v-if="task.type === 'modified'">
                                        <td :class="`${task.new?.name !== task.old?.name ? 'td-green' : ''}`">
                                          <span class="badge bg-green mr-2">New</span>{{ task.new?.name }}
                                        </td>
                                        <td :class="`${task.new?.description !== task.old?.description ? 'td-green' : ''}`">
                                          {{ task.new?.description }}
                                        </td>
                                        <td :class="`${task.new?.jan !== task.old?.jan ? 'td-green' : ''}`">{{ formatCurrency(task.new?.jan) }}</td>
                                        <td :class="`${task.new?.feb !== task.old?.feb ? 'td-green' : ''}`">{{ formatCurrency(task.new?.feb) }}</td>
                                        <td :class="`${task.new?.mar !== task.old?.mar ? 'td-green' : ''}`">{{ formatCurrency(task.new?.mar) }}</td>
                                        <td :class="`${task.new?.apr !== task.old?.apr ? 'td-green' : ''}`">{{ formatCurrency(task.new?.apr) }}</td>
                                        <td :class="`${task.new?.may !== task.old?.may ? 'td-green' : ''}`">{{ formatCurrency(task.new?.may) }}</td>
                                        <td :class="`${task.new?.jun !== task.old?.jun ? 'td-green' : ''}`">{{ formatCurrency(task.new?.jun) }}</td>
                                        <td :class="`${task.new?.jul !== task.old?.jul ? 'td-green' : ''}`">{{ formatCurrency(task.new?.jul) }}</td>
                                        <td :class="`${task.new?.aug !== task.old?.aug ? 'td-green' : ''}`">{{ formatCurrency(task.new?.aug) }}</td>
                                        <td :class="`${task.new?.sep !== task.old?.sep ? 'td-green' : ''}`">{{ formatCurrency(task.new?.sep) }}</td>
                                        <td :class="`${task.new?.oct !== task.old?.oct ? 'td-green' : ''}`">{{ formatCurrency(task.new?.oct) }}</td>
                                        <td :class="`${task.new?.nov !== task.old?.nov ? 'td-green' : ''}`">{{ formatCurrency(task.new?.nov) }}</td>
                                        <td :class="`${task.new?.dec !== task.old?.dec ? 'td-green' : ''}`">{{ formatCurrency(task.new?.dec) }}</td>
                                        <td :class="`${task.new?.total !== task.old?.total ? 'td-green' : ''}`">
                                          {{ formatCurrency(task.new?.total) }}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </vsa-content>
                          </vsa-item>
                        </vsa-list>
                      </div>
                      <div v-else class="row">
                        <div class="col-12 text-center text-info p-3">No Changes</div>
                      </div>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal size="xl" id="modalBudget" centered :title="listBudget ? listBudget.budget_item.budget_item : '-'" hide-footer>
      <div style="overflow: auto">
        <table class="table table-sm table-bordered p-0" style="table-layout: fixed; word-wrap: break-word">
          <thead>
            <tr>
              <!-- <th style="width: 150px;">GL</th> -->
              <!-- <th style="width: 100px;">TT</th> -->
              <th style="width: 150px" v-if="listBudget?.budget_item?.budget_item == 'IT Expense' && canTransferTask">Action</th>
              <th style="width: 300px">Budget Task</th>
              <th style="width: 300px">Description</th>
              <th style="width: 150px">January</th>
              <th style="width: 150px">February</th>
              <th style="width: 150px">March</th>
              <th style="width: 150px">April</th>
              <th style="width: 150px">May</th>
              <th style="width: 150px">June</th>
              <th style="width: 150px">July</th>
              <th style="width: 150px">August</th>
              <th style="width: 150px">September</th>
              <th style="width: 150px">October</th>
              <th style="width: 150px">November</th>
              <th style="width: 150px">December</th>
              <th style="width: 150px">Total</th>
            </tr>
          </thead>
          <!-- {{ listBudget.plan_item_opex_id }} -->
          <tbody>
            <tr v-for="(item, index) in listBudgetItems" :key="index">
              <td v-if="listBudget?.budget_item?.budget_item == 'IT Expense' && canTransferTask">
                <b-button variant="info" size="sm" block @click="transfer(item.id)"><span class="fe fe-scissors mr-2"></span>Transfer</b-button>
              </td>
              <td>{{ item.name }}</td>
              <td>{{ item.description }}</td>
              <td>
                <div class="text-right">
                  <span
                    class="text-success align-content-end w-full"
                    v-b-popover.hover.top="`Relocation from Internal Memo PK, this is the minimum value of this month can be edited`"
                    style="cursor: pointer"
                    >{{ getRelocateValue(item.code, 'jan') }}</span
                  >
                </div>
                {{ formatCurrency(item.jan) }}
              </td>
              <td>
                <div class="text-right">
                  <span
                    class="text-success align-content-end w-full"
                    v-b-popover.hover.top="`Relocation from Internal Memo PK, this is the minimum value of this month can be edited`"
                    style="cursor: pointer"
                    >{{ getRelocateValue(item.code, 'feb') }}</span
                  >
                </div>
                {{ formatCurrency(item.feb) }}
              </td>
              <td>
                <div class="text-right">
                  <span
                    class="text-success align-content-end w-full"
                    v-b-popover.hover.top="`Relocation from Internal Memo PK, this is the minimum value of this month can be edited`"
                    style="cursor: pointer"
                    >{{ getRelocateValue(item.code, 'mar') }}</span
                  >
                </div>
                {{ formatCurrency(item.mar) }}
              </td>
              <td>
                <div class="text-right">
                  <span
                    class="text-success align-content-end w-full"
                    v-b-popover.hover.top="`Relocation from Internal Memo PK, this is the minimum value of this month can be edited`"
                    style="cursor: pointer"
                    >{{ getRelocateValue(item.code, 'apr') }}</span
                  >
                </div>
                {{ formatCurrency(item.apr) }}
              </td>
              <td>
                <div class="text-right">
                  <span
                    class="text-success align-content-end w-full"
                    v-b-popover.hover.top="`Relocation from Internal Memo PK, this is the minimum value of this month can be edited`"
                    style="cursor: pointer"
                    >{{ getRelocateValue(item.code, 'may') }}</span
                  >
                </div>
                {{ formatCurrency(item.may) }}
              </td>
              <td>
                <div class="text-right">
                  <span
                    class="text-success align-content-end w-full"
                    v-b-popover.hover.top="`Relocation from Internal Memo PK, this is the minimum value of this month can be edited`"
                    style="cursor: pointer"
                    >{{ getRelocateValue(item.code, 'jun') }}</span
                  >
                </div>
                {{ formatCurrency(item.jun) }}
              </td>
              <td>
                <div class="text-right">
                  <span
                    class="text-success align-content-end w-full"
                    v-b-popover.hover.top="`Relocation from Internal Memo PK, this is the minimum value of this month can be edited`"
                    style="cursor: pointer"
                    >{{ getRelocateValue(item.code, 'jul') }}</span
                  >
                </div>
                {{ formatCurrency(item.jul) }}
              </td>
              <td>
                <div class="text-right">
                  <span
                    class="text-success align-content-end w-full"
                    v-b-popover.hover.top="`Relocation from Internal Memo PK, this is the minimum value of this month can be edited`"
                    style="cursor: pointer"
                    >{{ getRelocateValue(item.code, 'aug') }}</span
                  >
                </div>
                {{ formatCurrency(item.aug) }}
              </td>
              <td>
                <div class="text-right">
                  <span
                    class="text-success align-content-end w-full"
                    v-b-popover.hover.top="`Relocation from Internal Memo PK, this is the minimum value of this month can be edited`"
                    style="cursor: pointer"
                    >{{ getRelocateValue(item.code, 'sep') }}</span
                  >
                </div>
                {{ formatCurrency(item.sep) }}
              </td>
              <td>
                <div class="text-right">
                  <span
                    class="text-success align-content-end w-full"
                    v-b-popover.hover.top="`Relocation from Internal Memo PK, this is the minimum value of this month can be edited`"
                    style="cursor: pointer"
                    >{{ getRelocateValue(item.code, 'oct') }}</span
                  >
                </div>
                {{ formatCurrency(item.oct) }}
              </td>
              <td>
                <div class="text-right">
                  <span
                    class="text-success align-content-end w-full"
                    v-b-popover.hover.top="`Relocation from Internal Memo PK, this is the minimum value of this month can be edited`"
                    style="cursor: pointer"
                    >{{ getRelocateValue(item.code, 'nov') }}</span
                  >
                </div>
                {{ formatCurrency(item.nov) }}
              </td>
              <td>
                <div class="text-right">
                  <span
                    class="text-success align-content-end w-full"
                    v-b-popover.hover.top="`Relocation from Internal Memo PK, this is the minimum value of this month can be edited`"
                    style="cursor: pointer"
                    >{{ getRelocateValue(item.code, 'dec') }}</span
                  >
                </div>
                {{ formatCurrency(item.dec) }}
              </td>
              <td>{{ formatCurrency(item.total) }}</td>
            </tr>
            <tr>
              <!-- <td>{{ item.name }}</td> -->
              <td :colspan="listBudget?.budget_item?.budget_item == 'IT Expense' && canTransferTask ? 3 : 2" class="text-center font-weight-bold">
                Total:
              </td>
              <!-- {{ listBudget.summary ? listBudget.summary.jan : '0' }}/ -->
              <td>
                {{ formatCurrency(listBudget.summary ? listBudget.summary.jan : '0') }}
              </td>
              <td>
                {{ formatCurrency(listBudget.summary ? listBudget.summary.feb : '0') }}
              </td>
              <td>
                {{ formatCurrency(listBudget.summary ? listBudget.summary.mar : '0') }}
              </td>
              <td>
                {{ formatCurrency(listBudget.summary ? listBudget.summary.apr : '0') }}
              </td>
              <td>
                {{ formatCurrency(listBudget.summary ? listBudget.summary.may : '0') }}
              </td>
              <td>
                {{ formatCurrency(listBudget.summary ? listBudget.summary.jun : '0') }}
              </td>
              <td>
                {{ formatCurrency(listBudget.summary ? listBudget.summary.jul : '0') }}
              </td>
              <td>
                {{ formatCurrency(listBudget.summary ? listBudget.summary.aug : '0') }}
              </td>
              <td>
                {{ formatCurrency(listBudget.summary ? listBudget.summary.sep : '0') }}
              </td>
              <td>
                {{ formatCurrency(listBudget.summary ? listBudget.summary.oct : '0') }}
              </td>
              <td>
                {{ formatCurrency(listBudget.summary ? listBudget.summary.nov : '0') }}
              </td>
              <td>
                {{ formatCurrency(listBudget.summary ? listBudget.summary.dec : '0') }}
              </td>
              <td>
                {{ formatCurrency(listBudget.summary ? listBudget.summary.total : '0') }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axiosIns from '@/api/axios';
import { formatCurrency } from '@/utils/formatNumber';
import moment from 'moment';
import { VsaList, VsaItem, VsaHeading, VsaContent, VsaIcon } from 'vue-simple-accordion';

export default {
  props: {
    logId: Number,
    activity: String,
  },
  components: {
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent,
    VsaIcon,
  },
  computed: {
    detail() {
      return this.logData?.oldData;
    },
    departmentName() {
      return this.detail.fund_center?.department_name;
    },
    listUser() {
      let data = this.$store.getters['role/listData'].data;
      let after = data.filter((e) => e.roles_id == '4');
      return after;
    },
    budgetPlanTotal() {
      return this.formatCurrency(parseFloat(this.detail?.capex_total) + parseFloat(this.detail?.opex_total)) || 0;
    },
    createdAt() {
      return this.detail?.histories?.some((e) => e.activity == 'CREATE')
        ? moment(this.detail?.histories.find((e) => e.activity == 'CREATE').created_at).format('DD MMM YYYY HH:mm')
        : moment(this.logData.created_at).format('DD MMM YYYY HH:mm');
    },
    createdBy() {
      return this.detail?.histories?.some((e) => e.activity == 'CREATE')
        ? this.detail?.histories.find((e) => e.activity == 'CREATE')?.user?.fullname || 'System'
        : this.logData?.createdUser?.fullname || 'System';
    },
    updatedAt() {
      return this.detail?.histories?.length > 0
        ? moment(this.detail?.histories[0]?.created_at).format('DD MMM YYYY HH:mm')
        : moment(this.logData.created_at).format('DD MMM YYYY HH:mm');
    },
    updatedBy() {
      return this.detail?.histories?.length > 0 ? this.detail?.histories[0]?.user?.fullname || this.logData?.createdUser?.fullname || 'System' : '-';
    },
    clonedAt() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'CLONE')
          ? moment(this.detail?.histories.find((e) => e.activity == 'CLONE').created_at).format('DD MMM YYYY HH:mm')
          : '-'
        : '-';
    },
    clonedBy() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'CLONE')
          ? this.detail?.histories.find((e) => e.activity == 'CLONE')?.user?.fullname || 'System'
          : '-'
        : '-';
    },
    lockedAt() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'LOCK')
          ? moment(this.detail?.histories.find((e) => e.activity == 'LOCK').created_at).format('DD MMM YYYY HH:mm')
          : '-'
        : '-';
    },
    lockedBy() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'LOCK')
          ? this.detail?.histories.find((e) => e.activity == 'LOCK')?.user?.fullname || 'System'
          : '-'
        : '-';
    },
    approvedBy() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'APPROVE')
          ? this.detail?.histories.find((e) => e.activity == 'APPROVE')?.user?.fullname || 'System'
          : '-'
        : '-';
    },
    approvedAt() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'APPROVE')
          ? moment(this.detail?.histories.find((e) => e.activity == 'APPROVE').created_at).format('DD MMM YYYY HH:mm')
          : '-'
        : '-';
    },
    disapprovedBy() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'DISAPPROVE')
          ? this.detail?.histories.find((e) => e.activity == 'DISAPPROVE')?.user?.fullname || 'System'
          : '-'
        : '-';
    },
    disapprovedAt() {
      return this.detail?.histories?.length > 0
        ? this.detail?.histories?.some((e) => e.activity == 'DISAPPROVE')
          ? moment(this.detail?.histories.find((e) => e.activity == 'DISAPPROVE').created_at).format('DD MMM YYYY HH:mm')
          : '-'
        : '-';
    },
    deletedAt() {
      return this.logData.activity == 'Delete' ? moment(this.logData.created_at).format('DD MMM YYYY HH:mm') : '-';
    },
    deletedBy() {
      return this.logData.activity == 'Delete' ? this.logData.createdUser?.fullname : '-';
    },

    listBudgetItems() {
      const tasks = this.listBudget?.budget || [];

      if (this.filter_fund_center) {
        return tasks?.filter((item) => item.origin_fund_center.id == this.filter_fund_center);
      }
      return tasks;
    },
    changes() {
      return this.detail?.histories?.[0]?.changes?.groupedChanges || {};
    },
    opexChanges() {
      return {
        opexDiff: this.changes?.opexDiff || [],
        opexItemDiff: this.changes?.opexItemDiff || [],
        opexTaskDiff: this.changes?.opexTaskDiff || [],
      };
    },
    capexChanges() {
      return {
        capexDiff: this.changes?.capexDiff || [],
        capexTaskDiff: this.changes?.capexTaskDiff || [],
      };
    },
    planChanges() {
      return this.changes?.planDiff || [];
    },
  },
  data() {
    return {
      isLoading: true, // To show skeleton loader
      logData: {}, // To store the log data from API
      comparisonData: {}, // Store comparison of old and new values
      listBudget: '',
    };
  },
  methods: {
    async showModal() {
      await this.fetchHistoricalLog();
    },
    resetModal() {
      this.logData = {}; // Reset the log data
      this.comparisonData = {}; // Reset the comparison data
      this.isLoading = true; // Reset loading state
    },
    async fetchHistoricalLog() {
      if (!this.logId) return;
      this.resetModal();
      await axiosIns
        .get(`/historical-log/${this.logId}`)
        .then((response) => {
          const data = response.data.data;
          this.logData = data.detail;
          this.logData.data_changes = data.data_changes;
          this.comparisonData = this.getComparisonData(data.data_changes.old_value, data.data_changes.new_value);
          this.isLoading = false; // Set loading state to false when data is fetched
        })
        .catch((error) => {
          this.isLoading = true; // Stop loading if error occurs
          this.$swal('Error', error.response?.data?.error || 'Terjadi kesalahan, tidak dapat mengambil data.', 'error');
          this.resetModal();
          console.error('Error fetching historical log details:', error);
        });
    },
    formatDate(date, withTime = true) {
      if (withTime) {
        return date ? moment(date).format('DD MMMM YYYY HH:mm') : '-';
      }
      return date ? moment(date).format('DD MMMM YYYY') : '-';
    },
    formatCurrency(value) {
      return formatCurrency(value, 'Rp.') || '-';
    },
    getComparisonData(old_value, new_value) {
      // Memastikan old_value dan new_value bukan undefined atau null
      const oldValue = old_value || {};
      const newValue = new_value || {};

      const filterKeysMapping = (keys) => {
        return keys
          .filter(
            (key) =>
              !key.includes('id') && !key.includes('code_plan_budget') && !key.includes('code_actual_budget') && !key.includes('actual_budget_item')
          )
          .map((key) => {
            let transformedKey = key;
            if (transformedKey.includes('subject')) {
              transformedKey = transformedKey.replace(/subject/gi, 'number');
            }
            transformedKey = transformedKey.replace(/(po|pr|im|gl)/gi, (match) => match.toUpperCase());
            if (key == 'po_name') {
              transformedKey = 'PR Name';
            }
            if (key == 'im_number') {
              transformedKey = 'Internal Memo';
            }
            if (key == 'project_tag') {
              transformedKey = 'Project Tag';
            }
            return {
              original: key,
              transformed: transformedKey,
            };
          });
      };

      // Contoh pemakaian di kode pembanding data:
      const result = {};
      const oldMappings = filterKeysMapping(Object.keys(oldValue));
      const newMappings = filterKeysMapping(Object.keys(newValue));

      // Iterasi key dari oldValue
      oldMappings.forEach((mapping) => {
        const formattedKey = this.formatKey(mapping.transformed);
        result[formattedKey] = {
          old_value: oldValue[mapping.original] || '-',
          new_value: newValue[mapping.original] || '-',
        };
      });

      // Tambahkan key yang ada di newValue tapi tidak di oldValue
      newMappings.forEach((mapping) => {
        const formattedKey = this.formatKey(mapping.transformed);
        if (!result.hasOwnProperty(formattedKey)) {
          result[formattedKey] = {
            old_value: oldValue[mapping.original] || '-',
            new_value: newValue[mapping.original] || '-',
          };
        }
      });

      return result;
    },
    // Fungsi untuk mengubah key (mengganti "_" menjadi spasi dan kapitalisasi setiap kata)
    formatKey(key) {
      return key
        .replace(/_/g, ' ') // Ganti _ dengan spasi
        .replace(/\b\w/g, (char) => char.toUpperCase()); // Kapitalisasi setiap awal kata
    },
    titleCase(value) {
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    detailBudget(item) {
      this.listBudget = item;
      setTimeout(() => {
        this.$bvModal.show('modalBudget');
      }, 500);
    },
    getRelocateValue(code, month, unformated = false) {
      const relocateValue =
        this.detail.im_relocates
          ?.filter((item) => item.code_plan_budget === code && item.month === month)
          .reduce((acc, item) => acc + Number(item.relocate_value), 0) || 0;
      if (unformated) return relocateValue;
      return relocateValue > 0 ? `+ ${this.formatCurrency(relocateValue)}` : '';
    },
    getMonthName(month) {
      switch (month) {
        case 'jan':
          return 'January';
        case 'feb':
          return 'February';
        case 'mar':
          return 'March';
        case 'apr':
          return 'April';
        case 'may':
          return 'May';
        case 'jun':
          return 'June';
        case 'jul':
          return 'July';
        case 'aug':
          return 'August';
        case 'sep':
          return 'September';
        case 'oct':
          return 'October';
        case 'nov':
          return 'November';
        case 'dec':
          return 'December';
        default:
          return '-';
      }
    },
  },
};
</script>

<style>
.skeleton-loader {
  background-color: #e0e0e0;
  height: 20px;
  margin-bottom: 10px;
  border-radius: 4px;
}
.full-width-modal {
  min-width: 95vw !important;
  margin: 2.5% auto;
}
</style>
